import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showToast } from "../components/toastServices";
import APIService from "../components/postServices";
import {
  isValidEmail,
  isValidMobileNumber,
} from "../components/ValidationServices";
import PublicHeader from "../components/header";
import { RadioButton } from "primereact/radiobutton";
import generateRandomString from "../components/generateRandomString";
import { Dialog } from "primereact/dialog";
import "primeicons/primeicons.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useDataApi } from "../components/DataApiService";
import { formatDateYMD } from "../components/DateFormatServices";
import { ProgressSpinner } from "primereact/progressspinner";

const randomString = generateRandomString(9);

function RegistrationForm() {
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [success, setSuccess] = useState(false);
  const [instructions, setInstructions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentAcademicYear, setCurrentAcademicYear] = useState(null);
  const [feeCodesStructure, setFeeCodesStructure] = useState(null);

  const [allApisSuccessful, setAllApisSuccessful] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const status = params.get("status");
  const bank_ref_no = params.get("bank_ref_no");
  const amount = params.get("amount");
  const orderId = params.get("orderId");
  const tracking_id = params.get("tracking_id");

  const initialFormData = {
    nameOfPupil: "",
    applicantGender: 0,
    dateOfBirth: "",
    fatherName: "",
    motherName: "",
    citizenship: "",
    academicYear: "",
    class: "",
    previousSchool: "",
    mediumOfInstruction: "",
    previousClass: "",
    previousCurriculum: "",
    addressee: "",
    address1: "",
    address2: "",
    city: "",
    postCode: "",
    country: "",
    emailAddress: "",
    mobileNumber: "",
    phoneNumber: "",
    state: "",
    foodHabits: 0,
    StudentImage: "",
    guardianName: "",
    applicationStatus: 0,
    secondLanguage: 0,
    religion: "",
    companyID: 0,
    schoolID: 0,
    sendProspectus: 0,
    applicationCost: "",
    registrationCost: "",
    modeOfSale: "WEBSITE",
    referenceNo: "",
    MarkSheetFile: "",
  };

  console.log("status:", location.state);

  const [StudentFormData, setStudentFormData] = useState({});

  useEffect(() => {
    if (status === "update") {
      setInstructions(false);
      const data = location.state.data.applicationResponse;

      setStudentFormData({
        No: data.no,
        nameOfPupil: data.nameOfPupil,
        applicantGender: data.applicantGender,
        dateOfBirth: data.dateOfBirth,
        fatherName: data.fatherName,
        motherName: data.motherName,
        citizenship: data.citizenship,
        academicYear: data.academicYear,
        class: data.class,
        hostelAccommodation: 0,
        previousSchool: data.previousSchool,
        mediumOfInstruction: data.mediumOfInstruction,
        presentlyResidingWith: "",
        curriculumInterested: "",
        previousClass: data.previousClass,
        previousCurriculum: data.previousCurriculum,
        addressTo: "",
        addressee: data.addressee,
        address1: data.address1,
        address2: data.address2,
        city: data.city,
        postCode: data.postCode,
        country: data.country,
        emailAddress: data.emailAddress,
        mobileNumber: data.mobileNumber,
        phoneNumber: data.phoneNumber,
        state: data.state,
        foodHabits: data.foodHabits,
        StudentImage: data.studentImg,
        MarkSheetFile: data.markSheetFile,
        motherOccupation: data.motherOccupation,
        fatherOccupation: data.fatherOccupation,
        guardianName: data.guardianName,
        applicationStatus: 0,
        secondLanguage: data.secondLanguage,
        religion: data.religion,
        companyID: 0,
        schoolID: 0,
        sendProspectus: data.sendProspectus ? data.sendProspectus : 0,
        applicationCost: data.applicationCost,
        registrationCost: data.registrationCost,
        modeOfSale: "WEBSITE",
        referenceNo: "",
      });
    } else {
      {
        // setStudentFormData(initialFormData);
        // fetch academic year
        APIService.get(`/EnquiryApplications/CurrentAcademicYearRegistration`)
          .then((response) => {
            setCurrentAcademicYear(response.data.dataSet);
            setStudentFormData({
              ...initialFormData,
              academicYear: response.data.dataSet,
            });
          })
          .catch((error) => {
            // Handle API call errors here
            console.error("Error:", error);
            // showToast("error", response.data.responseMessage);
          });
      }
    }
  }, [status]);

  // useEffect(() => {
  //   if (currentAcademicYear)
  //     setStudentFormData({
  //       ...StudentFormData,
  //       academicYear: currentAcademicYear,
  //     });
  // }, [currentAcademicYear]);

  useEffect(() => {
    // fetch GetFeeCodesStructure
    if (currentAcademicYear)
      APIService.get(
        `/FeeStructure/GetFeeCodesStructure?academicYear=${currentAcademicYear}`
      )
        .then((response) => {
          setFeeCodesStructure(response.data.dataSet);
          // setInstructions(true);
        })
        .catch((error) => {
          // Handle API call errors here
          console.error("Error:", error);
          // showToast("error", response.data.responseMessage);
        });
  }, [currentAcademicYear]);

  const [countryListState, countryDataLists] = useDataApi();
  useEffect(() => {
    countryDataLists("/Masters/listCountryRegion");
  }, [success]);

  const countryDataList = countryListState.data;

  const [citizenshipListState, citizenshipDataLists] = useDataApi();
  useEffect(() => {
    citizenshipDataLists("/Masters/listCitizenship");
  }, [success]);

  const citizenship = citizenshipListState.data;

  useEffect(() => {
    switch (status) {
      case "Success":
      case "Failure":
      case "Aborted":
      case "Invalid":
        setInstructions(false);
        setPaymentSuccess(status === "Success");
        setSuccess(true);
        break;
      case "Completed":
        setInstructions(false);
        setPaymentSuccess(false);
        setSuccess(false);
        break;
      case "update":
        setInstructions(false);
        break;
      default:
        setSuccess(false);
        setInstructions(true);
        break;
    }
  }, [status]);

  const [UserFormError, setFormError] = React.useState({});

  const [error, setError] = React.useState(false);
  const [errors, setErrors] = useState({});

  const [religionState, dataListReligion] = useDataApi();
  useEffect(() => {
    dataListReligion("/Masters/religionlist");
  }, []);
  const religionList = religionState.data;

  const [classState, dataListClass] = useDataApi();
  useEffect(() => {
    dataListClass("/Masters/classGradeList");
  }, []);
  const classList = classState.data;

  const [curriculumState, dataListCurriculum] = useDataApi();
  useEffect(() => {
    dataListCurriculum("/Masters/listCurriculum");
  }, []);
  const curriculumList = curriculumState.data;

  // const [languageState, dataListlanguage] = useDataApi();
  // useEffect(() => {
  //   dataListlanguage("/Masters/listLanguages");
  // }, []);
  // const languageList = languageState.data;

  // Check if all API calls were successful
  useEffect(() => {
    if (
      religionState.data &&
      religionState.data.length > 0 &&
      classState.data &&
      classState.data.length > 0 &&
      curriculumState.data &&
      curriculumState.data.length > 0 &&
      countryListState.data &&
      countryListState.data.length > 0 &&
      citizenshipListState.data &&
      citizenshipListState.data.length > 0
    ) {
      setAllApisSuccessful(true);
    }
  }, [
    religionState.data,
    classState.data,
    curriculumState.data,
    countryListState.data,
    citizenshipListState.data,
  ]);

  const getRegistrationCost = (className) => {
    console.log("className", className);
    APIService.get(
      `/CCAvenuePayment/GetClassCardFeeDetails?academicYear=${currentAcademicYear}&Class=${className}`
    )
      .then((response) => {
        setStudentFormData({
          ...StudentFormData,
          class: className,
          applicationCost: response.data.dataSet.applicationCost,
          registrationCost: response.data.dataSet.registrationCost,
          applicationStatus: 0,
          modeOfSale: "WEBSITE",
        });
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
        // showToast("error", response.data.responseMessage);
      });
  };

  const languageList = [
    { code: 1, name: "Tamil" },
    { code: 2, name: "Hindi" },
    { code: 3, name: "Telugu" },
    { code: 4, name: "Malayalam" },
    { code: 5, name: "Kannada" },
    { code: 6, name: "French" },
    { code: 7, name: "Thai" },
  ];

  const StudentFormDataChange = (event) => {
    const { name, value } = event.target;
    console.log(name, value);
    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "emailAddress"
          ? value !== "" && !isValidEmail(value)
          : !isValidMobileNumber(value),
    };
    setErrors(newErrors);

    // console.log("value", event.target.files[0]);
    // Update the form state with the new value

    if (name === "StudentImage") {
      const uploadedFile = event.target.files[0]; // Get the uploaded file
      console.log(uploadedFile);
      if (uploadedFile) {
        const fileName = uploadedFile.name;
        const fileExtension = fileName.split(".").pop(); // Extract the file extension
        const fileSize = uploadedFile.size;

        const allowedExtensions = ["jpg", "jpeg", "png"];
        const maxFileSize = 200 * 1024; // Maximum file size in bytes (200KB)

        if (
          fileSize <= maxFileSize &&
          allowedExtensions.includes(fileExtension.toLowerCase())
        ) {
          console.log("Uploaded file meets size and type criteria");

          setStudentFormData({
            ...StudentFormData,
            [name]: uploadedFile,
          });
        } else {
          let error = "";
          if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
            error = "Invalid file type. Allowed types: JPG, JPEG, PNG.";
          } else if (fileSize > maxFileSize) {
            error = "File size exceeds the maximum allowed (200KB).";
          }
          handleError(error, "StudentImage");
        }
      }
    } else if (name === "MarkSheetFile") {
      const uploadedFile = event.target.files[0]; // Get the uploaded file
      console.log(uploadedFile);
      if (uploadedFile) {
        const fileName = uploadedFile.name;
        const fileExtension = fileName.split(".").pop(); // Extract the file extension
        const fileSize = uploadedFile.size;

        const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "PDF"];
        const maxFileSize = 1000 * 1024; // Maximum file size in bytes (1MB)

        if (
          fileSize <= maxFileSize &&
          allowedExtensions.includes(fileExtension.toLowerCase())
        ) {
          console.log("Uploaded file meets size and type criteria");

          setStudentFormData({
            ...StudentFormData,
            [name]: uploadedFile,
          });
        } else {
          let error = "";
          if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
            error = "Invalid file type. Allowed types: JPG, JPEG, PNG, PDF.";
          } else if (fileSize > maxFileSize) {
            error = "File size exceeds the maximum allowed (1MB).";
          }
          handleError(error, "MarkSheetFile");
        }
      }
    } else if (name === "class") {
      console.log(name, value);
      getRegistrationCost(value);
    } else {
      setStudentFormData({
        ...StudentFormData,
        [name]: value,
      });
    }
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

  // console.log(StudentFormData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isValid = true;
    let fatherName = StudentFormData.fatherName;
    let motherName = StudentFormData.motherName;
    let fatherOccupation = StudentFormData.fatherOccupation;
    let motherOccupation = StudentFormData.motherOccupation;
    let addressee = StudentFormData.addressee;
    let guardianName = StudentFormData.guardianName;
    let emailAddress = StudentFormData.emailAddress;
    let mobileNumber = StudentFormData.mobileNumber;
    let phoneNumber = StudentFormData.phoneNumber;
    let address1 = StudentFormData.address1;
    let address2 = StudentFormData.address2;
    let city = StudentFormData.city;
    let postCode = StudentFormData.postCode;
    let state = StudentFormData.state;
    let country = StudentFormData.country;
    let nameOfPupil = StudentFormData.nameOfPupil;
    let applicantGender = StudentFormData.applicantGender;
    let dateOfBirth = StudentFormData.dateOfBirth;
    let citizenship = StudentFormData.citizenship;
    let religion = StudentFormData.religion;
    let foodHabits = StudentFormData.foodHabits;
    let academicYear = StudentFormData.academicYear;
    let Class = StudentFormData.class;
    let previousSchool = StudentFormData.previousSchool;
    let previousClass = StudentFormData.previousClass;
    let previousCurriculum = StudentFormData.previousCurriculum;
    let mediumOfInstruction = StudentFormData.mediumOfInstruction;
    let secondLanguage = StudentFormData.secondLanguage;
    let StudentImage = StudentFormData.StudentImage;

    if (!fatherName) {
      handleError("Please input father's name", "fatherName");
      isValid = false;
    }
    if (!motherName) {
      handleError("Please input mother's name", "motherName");
      isValid = false;
    }
    if (!fatherOccupation) {
      handleError("Please input father's o'ccupation", "fatherOccupation");
      isValid = false;
    }
    if (!motherOccupation) {
      handleError("Please input mother's occupation", "motherOccupation");
      isValid = false;
    }
    if (!emailAddress) {
      handleError("Please input email address", "emailAddress");
      isValid = false;
    }
    if (!mobileNumber) {
      handleError("Please input mobile number", "mobileNumber");
      isValid = false;
    }
    if (!phoneNumber) {
      handleError("Please input phone number", "phoneNumber");
      isValid = false;
    }
    if (!address1) {
      handleError("Please input address", "address1");
      isValid = false;
    }
    if (!address2) {
      handleError("Please input address", "address2");
      isValid = false;
    }
    if (!city) {
      handleError("Please input city", "city");
      isValid = false;
    }
    if (!postCode) {
      handleError("Please input postCode", "postCode");
      isValid = false;
    }
    if (!state) {
      handleError("Please input state", "state");
      isValid = false;
    }
    if (!country) {
      handleError("Please select country", "country");
      isValid = false;
    }
    if (addressee === 0 || addressee === "") {
      handleError("Please Select Address Communication To", "addressee");
      isValid = false;
    }
    if (!guardianName) {
      handleError("Please input guardian name", "guardianName");
      isValid = false;
    }
    if (!nameOfPupil) {
      handleError("Please input name", "nameOfPupil");
      isValid = false;
    }
    if (applicantGender === 0) {
      handleError("Please select gender", "applicantGender");
      isValid = false;
    }
    if (!dateOfBirth) {
      handleError("Please input date of birth", "dateOfBirth");
      isValid = false;
    }
    if (!citizenship) {
      handleError("Please input citizenship", "citizenship");
      isValid = false;
    }
    if (!religion) {
      handleError("Please input religion", "religion");
      isValid = false;
    }
    if (foodHabits === 0) {
      handleError("Please Select foodHabits", "foodHabits");
      isValid = false;
    }
    if (!academicYear) {
      handleError("Please input academic year", "academicYear");
      isValid = false;
    }
    if (!Class) {
      handleError("Please select class", "class");
      isValid = false;
    }
    if (!previousSchool) {
      handleError("Please input School name", "previousSchool");
      isValid = false;
    }
    if (!previousClass) {
      handleError("Please select class", "previousClass");
      isValid = false;
    }
    if (!previousCurriculum) {
      handleError("Please Select Curriculum", "previousCurriculum");
      isValid = false;
    }
    if (!mediumOfInstruction) {
      handleError("Please select medium of instruction", "mediumOfInstruction");
      isValid = false;
    }
    if (!secondLanguage) {
      handleError("Please Select second language", "secondLanguage");
      isValid = false;
    }
    // if (!StudentImage) {
    //   handleError("Please upload Image", "StudentImage");
    //   isValid = false;
    // }

    if (isValid) {
      // let registrationFee;

      // if (Class >= 1 && Class <= 5) {
      //   registrationFee = 750;
      // } else if (Class >= 6 && Class <= 10) {
      //   registrationFee = 1000;
      // } else if (Class >= 11 && Class <= 12) {
      //   registrationFee = 2000;
      // } else {
      //   // Handle the case where the class is not in the specified ranges
      //   registrationFee = 0;
      // }
      // StudentFormData.registrationCost = registrationFee;

      // if (StudentFormData.sendProspectus !== 0) {
      //   StudentFormData.applicationCost = 0;
      // }

      StudentFormData.referenceNo =
        randomString +
        "-" +
        StudentFormData.academicYear +
        "-" +
        StudentFormData.class +
        "-" +
        StudentFormData.nameOfPupil;

      const formData = new FormData();
      Object.entries(StudentFormData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      try {
        const response = await APIService.Post(
          "/EnquiryApplications/CreateEnquiryApplication",
          formData
        );

        if (response.responseCode === 1) {
          // showToast("success", response.responseMessage);
          // Redirect to another page on successful form submission
          // history.push("/registration/submit");
          setLoading(false);
          navigate("/registration/submit", {
            state: { data: response.dataSet },
          });
          // clearValues();
          // setSuccess(true);
        }
      } catch (error) {
        showToast("error", error.response.data.responseMessage);
      }
    } else {
      showToast("error", "Kindly complete all required fields.");
    }
    setLoading(false);
  };

  const clearValues = () => {
    setStudentFormData(initialFormData);
  };

  const breadcrumb = [{ label: "Register", url: "/registration/form" }];

  const hideDialog = () => {
    setSuccess(false);

    // navigate("stjudesonline.in", { replace: true });
    window.location.replace("http://stjudesonline.in");
  };

  const hideInstructionDialog = () => {
    setInstructions(false);
  };

  const header = (
    <>
      <i
        className={
          paymentSuccess === true ? "pi pi-check-circle" : "pi pi-times-circle"
        }
        style={{
          fontSize: "2.5rem",
          color: paymentSuccess === true ? "green" : "red",
        }}
      ></i>
    </>
  );
  const footer = (
    <div className="flex flex-wrap justify-content-end gap-2">
      <Button
        label="Ok"
        // size="small"
        severity="info"
        onClick={hideDialog}
      />
    </div>
  );

  const instructionFooter = (
    <div className="flex flex-wrap justify-content-center gap-2">
      <Button
        label="Register Now"
        severity="success"
        onClick={hideInstructionDialog}
        // style={{ width: "40%" }}
      />
    </div>
  );

  console.log("StudentFormData", StudentFormData);

  return (
    <div className="main-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PublicHeader breadcrumb={breadcrumb} title={"Register"} />
      <div className="content-wrapper  mt-10">
        <div className="col-md-12">
          <h3>
            Registration Form
            <small>Register student for admission into classes I to IX</small>
          </h3>

          {allApisSuccessful ? (
            <div className=" reg">
              <div className="box-header">
                <h3 className="box-title">Parent's Information</h3>
              </div>
              <div className="box-body">
                <div className="row">
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Father's Name{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Father's Name"
                            className="form-control form-control-sm"
                            id="fatherName"
                            name="fatherName"
                            value={StudentFormData.fatherName}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "fatherName")}
                          />
                        </div>
                        {error && UserFormError.fatherName && (
                          <div style={{ color: "red" }}>
                            {UserFormError.fatherName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Father's Occupation{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Father's Occupation"
                            className="form-control form-control-sm"
                            id="fatherOccupation"
                            name="fatherOccupation"
                            value={StudentFormData.fatherOccupation}
                            onChange={StudentFormDataChange}
                            onFocus={() =>
                              handleError(null, "fatherOccupation")
                            }
                          />
                        </div>
                        {error && UserFormError.fatherOccupation && (
                          <div style={{ color: "red" }}>
                            {UserFormError.fatherOccupation}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mother's Name
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Mother's Name"
                            className="form-control form-control-sm"
                            id="motherName"
                            name="motherName"
                            value={StudentFormData.motherName}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "motherName")}
                          />
                        </div>
                        {error && UserFormError.motherName && (
                          <div style={{ color: "red" }}>
                            {UserFormError.motherName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mother's Occupation
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Mother's Occupation"
                            className="form-control form-control-sm"
                            id="motherOccupation"
                            name="motherOccupation"
                            value={StudentFormData.motherOccupation}
                            onChange={StudentFormDataChange}
                            onFocus={() =>
                              handleError(null, "motherOccupation")
                            }
                          />
                        </div>
                        {error && UserFormError.motherOccupation && (
                          <div style={{ color: "red" }}>
                            {UserFormError.motherOccupation}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Address Communication To{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="addressee"
                          value="FATHER"
                          onChange={StudentFormDataChange}
                          checked={StudentFormData.addressee === "FATHER"}
                          onFocus={() => handleError(null, "addressee")}
                        />

                        <label className="ml-2 mr-2">Father</label>

                        <RadioButton
                          inputId="ingredient1"
                          name="addressee"
                          value="MOTHER"
                          onChange={StudentFormDataChange}
                          checked={StudentFormData.addressee === "MOTHER"}
                          onFocus={() => handleError(null, "addressee")}
                        />

                        <label className="ml-2">Mother</label>
                        {error && UserFormError.addressee && (
                          <div style={{ color: "red" }}>
                            {UserFormError.addressee}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Guardian's Name
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Guardian's Name"
                            className="form-control form-control-sm"
                            id="guardianName"
                            name="guardianName"
                            value={StudentFormData.guardianName}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "guardianName")}
                          />
                        </div>
                        {error && UserFormError.guardianName && (
                          <div style={{ color: "red" }}>
                            {UserFormError.guardianName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Email
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Email Address"
                            className="form-control form-control-sm"
                            id="emailAddress"
                            name="emailAddress"
                            value={StudentFormData.emailAddress}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "emailAddress")}
                          />
                        </div>
                        {error && UserFormError.emailAddress && (
                          <div style={{ color: "red" }}>
                            {UserFormError.emailAddress}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        WhatsApp Number
                        <i aria-hidden="true" className="redColor">
                          {" "}
                          *{" "}
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.mobileNumber ? "is-invalid" : ""
                            }`}
                            placeholder="1234567890"
                            id="mobileNumber"
                            name="mobileNumber"
                            value={StudentFormData.mobileNumber}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "mobileNumber")}
                          />
                        </div>
                        {errors.mobileNumber && (
                          <div className="invalid-feedback">
                            Invalid mobile number
                          </div>
                        )}
                        {error && UserFormError.mobileNumber && (
                          <div style={{ color: "red" }}>
                            {UserFormError.mobileNumber}
                          </div>
                        )}{" "}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Phone Number
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            placeholder="1234567890"
                            className="form-control form-control-sm "
                            id="phoneNumber"
                            name="phoneNumber"
                            value={StudentFormData.phoneNumber}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "phoneNumber")}
                          />
                        </div>
                        {error && UserFormError.phoneNumber && (
                          <div style={{ color: "red" }}>
                            {UserFormError.phoneNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Address
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Address Line 1"
                            className="form-control form-control-sm "
                            id="address1"
                            name="address1"
                            value={StudentFormData.address1}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "address1")}
                          />
                        </div>
                        {error && UserFormError.address1 && (
                          <div style={{ color: "red" }}>
                            {UserFormError.address1}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        {/* Address Line 2 */}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Address Line 2"
                            className="form-control form-control-sm "
                            id="address2"
                            name="address2"
                            value={StudentFormData.address2}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "address2")}
                          />
                        </div>
                        {error && UserFormError.address2 && (
                          <div style={{ color: "red" }}>
                            {UserFormError.address2}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        {/* Address Line 3 */}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Address Line 3"
                            className="form-control form-control-sm "
                            id="address3"
                            name="address3"
                            value={StudentFormData.address3}
                            onChange={StudentFormDataChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        City
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="City"
                            className="form-control form-control-sm "
                            id="city"
                            name="city"
                            value={StudentFormData.city}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "city")}
                          />
                        </div>
                        {error && UserFormError.city && (
                          <div style={{ color: "red" }}>
                            {UserFormError.city}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Post Code
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Post Code"
                            className="form-control form-control-sm "
                            id="postCode"
                            name="postCode"
                            value={StudentFormData.postCode}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "postCode")}
                          />
                        </div>
                        {error && UserFormError.postCode && (
                          <div style={{ color: "red" }}>
                            {UserFormError.postCode}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        State
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="State"
                            className="form-control form-control-sm "
                            id="state"
                            name="state"
                            value={StudentFormData.state}
                            onChange={StudentFormDataChange}
                            onFocus={() => handleError(null, "state")}
                          />
                        </div>
                        {error && UserFormError.state && (
                          <div style={{ color: "red" }}>
                            {UserFormError.state}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Country
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="Country"
                            id="country"
                            name="country"
                            value={StudentFormData.country}
                            onFocus={() => handleError(null, "country")}
                          >
                            <option value=""> </option>
                            {countryDataList.length !== 0
                              ? countryDataList.map((item) => (
                                  <option key={item.code} value={item.name}>
                                    {item.name}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserFormError.country && (
                          <div style={{ color: "red" }}>
                            {UserFormError.country}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-header">
                <h3 className="box-title">Student's Information</h3>
              </div>
              <div className="box-body">
                <div className="row">
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Name
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            className="form-control form-control-sm"
                            placeholder="Name"
                            type="text"
                            id="nameOfPupil"
                            name="nameOfPupil"
                            value={StudentFormData.nameOfPupil}
                            onChange={StudentFormDataChange}
                            required
                            onFocus={() => handleError(null, "nameOfPupil")}
                          />
                        </div>
                        {error && UserFormError.nameOfPupil && (
                          <div style={{ color: "red" }}>
                            {UserFormError.nameOfPupil}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="form-group row">
                        <label className="col-12 md:col-12 xl:col-4 col-form-label">
                          Middle Name
                          <i aria-hidden="true" className="ml-2 redColor">
                            {" "}
                            *{" "}
                          </i>{" "}
                        </label>
                        <div className="col-12 md:col-12 xl:col-8">
                          <input
                            className="form-control form-control-sm"
                            placeholder="Name"
                            type="text"
                            id="middleNameOfStudent"
                            name="middleNameOfStudent"
                            value={StudentFormData.middleNameOfStudent}
                            onChange={StudentFormDataChange}
                            required
                          />
                        </div>
                      </div>
    
                      <div className="form-group row">
                        <label className="col-12 md:col-12 xl:col-4 col-form-label">
                          Last Name
                          <i aria-hidden="true" className="ml-2 redColor">
                            {" "}
                            *{" "}
                          </i>{" "}
                        </label>
                        <div className="col-12 md:col-12 xl:col-8">
                          <input
                            className="form-control form-control-sm"
                            placeholder="Name"
                            type="text"
                            id="lastNameOfStudent"
                            name="lastNameOfStudent"
                            value={StudentFormData.lastNameOfStudent}
                            onChange={StudentFormDataChange}
                            required
                          />
                        </div>
                      </div> */}

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Gender{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="applicantGender"
                          value="1"
                          onChange={StudentFormDataChange}
                          checked={
                            StudentFormData.applicantGender === "1" ||
                            StudentFormData.applicantGender === 1
                          }
                          onFocus={() => handleError(null, "applicantGender")}
                        />

                        <label className="ml-2 mr-2">Male</label>

                        <RadioButton
                          inputId="ingredient1"
                          name="applicantGender"
                          value="2"
                          onChange={StudentFormDataChange}
                          checked={
                            StudentFormData.applicantGender === "2" ||
                            StudentFormData.applicantGender === 2
                          }
                          onFocus={() => handleError(null, "applicantGender")}
                        />

                        <label className="ml-2">Female</label>

                        {error && UserFormError.applicantGender && (
                          <div style={{ color: "red" }}>
                            {UserFormError.applicantGender}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Date Of Birth
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            id="dateOfBirth"
                            name="dateOfBirth"
                            value={
                              StudentFormData.dateOfBirth &&
                              formatDateYMD(StudentFormData.dateOfBirth)
                            }
                            onChange={StudentFormDataChange}
                            // onBlur={handleDobBlur}
                            onFocus={() => handleError(null, "dateOfBirth")}
                          />
                        </div>
                        {error && UserFormError.dateOfBirth && (
                          <div style={{ color: "red" }}>
                            {UserFormError.dateOfBirth}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Citizenship
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="Citizenship"
                            id="citizenship"
                            name="citizenship"
                            value={StudentFormData.citizenship}
                            onFocus={() => handleError(null, "citizenship")}
                          >
                            <option value=""> </option>
                            {citizenship.length !== 0
                              ? citizenship.map((item) => (
                                  <option
                                    key={item.code}
                                    value={item.description}
                                  >
                                    {item.description}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserFormError.citizenship && (
                          <div style={{ color: "red" }}>
                            {UserFormError.citizenship}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Religion
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="religion"
                            id="religion"
                            name="religion"
                            value={StudentFormData.religion}
                            onFocus={() => handleError(null, "religion")}
                          >
                            <option value=""> </option>
                            {religionList.length !== 0
                              ? religionList.map((item) => (
                                  <option key={item.code} value={item.code}>
                                    {item.code}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>{" "}
                        {error && UserFormError.religion && (
                          <div style={{ color: "red" }}>
                            {UserFormError.religion}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Diet{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="foodHabits"
                          value="1"
                          onChange={StudentFormDataChange}
                          checked={
                            StudentFormData.foodHabits === "1" ||
                            StudentFormData.foodHabits === 1
                          }
                          onFocus={() => handleError(null, "foodHabits")}
                        />

                        <label className="ml-2 mr-2">Vegetarian</label>

                        <RadioButton
                          inputId="ingredient1"
                          name="foodHabits"
                          value="2"
                          onChange={StudentFormDataChange}
                          checked={
                            StudentFormData.foodHabits === "2" ||
                            StudentFormData.foodHabits === 2
                          }
                          onFocus={() => handleError(null, "foodHabits")}
                        />

                        <label className="ml-2">Non-Vegetarian</label>

                        {error && UserFormError.foodHabits && (
                          <div style={{ color: "red" }}>
                            {UserFormError.foodHabits}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 md:col-12 xl:col-6  bg-gray-light p-2">
                    <div className="row">
                      <div className="col-12 md:col-12 xl:col-6">
                        <div className="form-group row">
                          <label className="col-sm-5 col-form-label">
                            Registration for
                            <i aria-hidden="true" className="ml-2 redColor">
                              {" "}
                              *{" "}
                            </i>{" "}
                          </label>
                          <div className="col-sm-7">
                            <input
                              className="form-control form-control-sm"
                              placeholder="academicYear"
                              type="text"
                              id="academicYear"
                              name="academicYear"
                              // value={StudentFormData.academicYear}
                              value={
                                StudentFormData.academicYear
                                  ? `Academic Year ${StudentFormData.academicYear}`
                                  : `Academic Year ${currentAcademicYear}`
                              }
                              onChange={StudentFormDataChange}
                              required
                              disabled
                              onFocus={() => handleError(null, "academicYear")}
                            />
                            {error && UserFormError.academicYear && (
                              <div style={{ color: "red" }}>
                                {UserFormError.academicYear}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-12 xl:col-6">
                        <div className="form-group row">
                          <label className="col-12 md:col-12 xl:col-4 col-form-label">
                            In Standard
                            <i aria-hidden="true" className="ml-2 redColor">
                              {" "}
                              *{" "}
                            </i>{" "}
                          </label>
                          <div className="col-12 md:col-12 xl:col-8">
                            <div className="input-group">
                              <select
                                onChange={StudentFormDataChange}
                                className="k-dropdownlist form-control form-control-sm"
                                style={{ width: "300px" }}
                                placeholder="class"
                                id="class"
                                name="class"
                                value={StudentFormData.class}
                                onFocus={() => handleError(null, "class")}
                              >
                                <option value=""> </option>
                                {classList.length !== 0
                                  ? classList.map((item) => (
                                      <option key={item.code} value={item.code}>
                                        {item.description}
                                      </option>
                                    ))
                                  : ""}
                              </select>
                            </div>{" "}
                            {error && UserFormError.class && (
                              <div style={{ color: "red" }}>
                                {UserFormError.class}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Name of Present School
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            id="previousSchool"
                            name="previousSchool"
                            placeholder="School name"
                            value={StudentFormData.previousSchool}
                            onChange={StudentFormDataChange}
                            required
                            onFocus={() => handleError(null, "previousSchool")}
                          />
                        </div>
                        {error && UserFormError.previousSchool && (
                          <div style={{ color: "red" }}>
                            {UserFormError.previousSchool}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Present Curriculum
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="previousCurriculum"
                            id="previousCurriculum"
                            name="previousCurriculum"
                            value={StudentFormData.previousCurriculum}
                            onFocus={() =>
                              handleError(null, "previousCurriculum")
                            }
                          >
                            <option value=""> </option>
                            {classList.length !== 0
                              ? curriculumList.map((item) => (
                                  <option key={item.code} value={item.code}>
                                    {item.code}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserFormError.previousCurriculum && (
                          <div style={{ color: "red" }}>
                            {UserFormError.previousCurriculum}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Medium of Instruction
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="mediumOfInstruction"
                            id="mediumOfInstruction"
                            name="mediumOfInstruction"
                            onFocus={() =>
                              handleError(null, "mediumOfInstruction")
                            }
                          >
                            <option value=""> </option>
                            <option value="ENGLISH">English</option>
                          </select>
                        </div>
                        {error && UserFormError.mediumOfInstruction && (
                          <div style={{ color: "red" }}>
                            {UserFormError.mediumOfInstruction}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Last/Present Class
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="previousClass"
                            id="previousClass"
                            name="previousClass"
                            value={StudentFormData.previousClass}
                            onFocus={() => handleError(null, "previousClass")}
                          >
                            <option value=""> </option>
                            {classList.length !== 0
                              ? classList.map((item) => (
                                  <option key={item.code} value={item.code}>
                                    {item.description}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserFormError.previousClass && (
                          <div style={{ color: "red" }}>
                            {UserFormError.previousClass}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Second Language
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <select
                            onChange={StudentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="secondLanguage"
                            id="secondLanguage"
                            name="secondLanguage"
                            value={StudentFormData.secondLanguage}
                            onFocus={() => handleError(null, "secondLanguage")}
                          >
                            <option value=""> </option>
                            {languageList.length !== 0
                              ? languageList.map((item) => (
                                  <option key={item.code} value={item.code}>
                                    {item.name}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserFormError.secondLanguage && (
                          <div style={{ color: "red" }}>
                            {UserFormError.secondLanguage}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-header">
                <h3 className="box-title">Attachments</h3>
              </div>
              <div className="box-body">
                <div className="row">
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Photograph{" "}
                        {/* <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "} */}
                        <br></br>
                        <small>
                          Maximum file size 200 KB and JPEG, JPG, PNG files are
                          allowed
                        </small>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control  form-control-sm"
                            id="StudentImage"
                            name="StudentImage"
                            onChange={StudentFormDataChange}
                            style={{ width: "300px" }}
                            placeholder="StudentImage"
                            // value={StudentFormData.StudentImage}
                            onFocus={() => handleError(null, "StudentImage")}
                          />
                        </div>

                        {error && UserFormError.StudentImage && (
                          <div style={{ color: "red" }}>
                            {UserFormError.StudentImage}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mark Sheet <br></br>
                        <small>
                          Attach if available. Maximum file size allowed is 2 MB
                          and JPEG, JPG, PNG, PDF files are allowed
                        </small>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="file"
                            accept="image/*, application/pdf"
                            className="form-control  form-control-sm"
                            id="MarkSheetFile"
                            name="MarkSheetFile"
                            onChange={StudentFormDataChange}
                            style={{ width: "300px" }}
                            placeholder="Mark Sheets"
                            // value={StudentFormData.MarkSheetFile}
                            onFocus={() => handleError(null, "MarkSheetFile")}
                          />
                        </div>
                        {error && UserFormError.MarkSheetFile && (
                          <div style={{ color: "red" }}>
                            {UserFormError.MarkSheetFile}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label className="col-sm-6 col-form-label">
                        Have you received a copy of the prospectus?{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-sm-6">
                        <RadioButton
                          inputId="ingredient1"
                          name="sendProspectus"
                          value="1"
                          onChange={StudentFormDataChange}
                          checked={StudentFormData.sendProspectus === "1"}
                        />

                        <label className="ml-2 mr-2">YES</label>

                        <RadioButton
                          inputId="ingredient1"
                          name="sendProspectus"
                          value="0"
                          onChange={StudentFormDataChange}
                          checked={
                            StudentFormData.sendProspectus === "0" ||
                            StudentFormData.sendProspectus === 0
                          }
                        />

                        <label className="ml-2">No</label>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="button-container pull-right">
                <Button
                  label="Next"
                  severity="danger"
                  icon="pi pi-arrow-right"
                  loading={loading}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          ) : (
            <div className="card flex justify-content-center">
              <ProgressSpinner />
            </div>
          )}
        </div>

        <Dialog
          // maximizable
          visible={success}
          style={{ width: "40vw", background: "#ff6358" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Payment Result"
          modal
          className="p-fluid "
          onHide={hideDialog}
        >
          <br />
          <div className="row  justify-content-center">
            <div className=" flex text-center">
              <Card
                // title={paymentSuccess === true ? "Success" : "Failed"}
                title={
                  status === "Success"
                    ? "Success"
                    : status === "Failure"
                    ? "Failed"
                    : status === "Aborted"
                    ? "Cancelled"
                    : ""
                }
                // subTitle="Subtitle"
                footer={footer}
                header={header}
                className="md:w-30rem"
                style={{ boxShadow: "none" }}
              >
                <h4 className="m-0">
                  {paymentSuccess === true
                    ? "Payment completed successfully"
                    : "Transaction unsuccessful"}
                </h4>
                <p>
                  {status === "Success"
                    ? "Thank you for registering with us. You will soon receive notifications on WhatsApp and via email. For any further queries, please email us at sjps@stjudesonline.in or feel free to contact us directly at 04266 275709 / 04266 275809."
                    : status === "Failure"
                    ? "Apologies, but your transaction has not been approved. If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                    : status === "Aborted"
                    ? "If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                    : ""}
                </p>
                <p className="" style={{ fontSize: "medium" }}>
                  {orderId && `Order Id : ${orderId}`}
                </p>
                <p className="" style={{ fontSize: "medium" }}>
                  {tracking_id === 0 ? " " : `Transaction Id : ${tracking_id}`}
                </p>
                <p className="" style={{ fontSize: "medium" }}>
                  {amount === 0 ? " " : `Amount : INR ${amount ?? 0}`}
                </p>
              </Card>
            </div>
          </div>
        </Dialog>

        <Dialog
          // maximizable
          visible={instructions}
          style={{ width: "60vw", background: "#ff6358" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Instruction"
          modal
          className="p-fluid "
          onHide={hideInstructionDialog}
        >
          <br />
          <div className="row  justify-content-center">
            <div className=" flex text-center">
              <Card
                title="Online Registration"
                // subTitle="Subtitle"
                footer={instructionFooter}
                // header={header}
                className="md:w-50rem"
                style={{ boxShadow: "none" }}
              >
                <div className="text-left">
                  <ol className="paralist">
                    <li>
                      Children are admitted in the school from class I. The
                      minimum age for admission to class I is five plus and the
                      child must have attended kindergarten for at least 2
                      years.
                    </li>
                    <li>
                      Admission to classes from I to IX and XI will be
                      considered as per the availability of seats in each class.
                    </li>
                    <li>
                      Applications can be made online by clicking the "Apply
                      Now" button below and by completing the registration form.
                    </li>
                    <li>
                      On the registration form attach photograph and marksheet
                      of the last attended exam.
                    </li>
                    <li>
                      On successful completion of the registration form with
                      attachments, pay the registration amount online.
                    </li>
                    <li>
                      Once the payment is made your registration is complete and
                      you will receive an acknowledgement email with your
                      application number.
                    </li>
                    <li>
                      Registration fees are
                      {feeCodesStructure &&
                        feeCodesStructure.feeCodesWithDescription.map(
                          (data, index) => (
                            <span key={index}>
                              {" "}
                              <i className="fa fa-inr"></i>{" "}
                              <b>{data.registrationCost}</b>/- (for classes{" "}
                              {data.class})
                            </span>
                          )
                        )}
                      . The cost of prospectus is <i className="fa fa-inr "></i>{" "}
                      <b>
                        {feeCodesStructure && feeCodesStructure.prospectersFee}
                      </b>
                      .
                    </li>
                    <li>School prospectus will be sent to you by post.</li>
                    <li>
                      Intimation about the availability of seats, the date for
                      the entrance exam and a set of model question papers in
                      english, maths and second language will be sent before the
                      first week of January.
                    </li>
                    <li>
                      Entrance exams are scheduled for the first three weeks of
                      February.
                    </li>
                    <li>
                      Admissions will be based on the child's performance in the
                      entrance exam and previous academic records.{" "}
                    </li>
                  </ol>
                </div>
              </Card>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default RegistrationForm;
